// 统一管理接口
import { get, post } from './http';


// 接口地址配置 API_ROOT
// config/dev.env.js   开发环境地址
// config/dev.env.js   生产环境地址
const root = process.env.API_ROOT;
const COMM_HOST = process.env.COMM_HOST;
const XS_URL= process.env.XS_URL;
// 接口域名
const baseUrl = {
  api_1: '/apis_v1', //
}



const httpApi = {
  joinSc(sid){  // 收藏送活动
    return get(root + '/joinSC04002.do?v=1.0&aid=1&accessFrom=4&cv=2.5.3&sid='+sid);
  },
  getMemberId(sid){ //根据sid拿memberid
    return get(`${COMM_HOST}/router/rest?method=ssn.member.get&v=1.0&aid=${1}&sid=${sid}`,{sid},true);
  },
  getMemberList(sid){ //根据sid拿memberid
    return get(`${COMM_HOST}/router/rest?method=ssn.member.invite.list&v=1.0&aid=${1}&sid=${sid}`,{sid},true);
  },
  smsLogin(data = {}){//验证码登录
    return post(`${COMM_HOST}/router/rest?method=ifeng.member.phone_login`, {...data,...{v:"1.0",cv:"3.6.0"}});
  },
  verifyPhone(aid,data){ //118活动验证注册用户是否存在
    return post(`${COMM_HOST}/router/rest?method=ifeng.member.verify&v=1.0&aid=${aid}`,data);
  },
  getVerifyCode(aid,data,appName){ //获取118活动验证码
    return post(`${COMM_HOST}/router/rest?method=ifeng.tq.sms.send&v=1.0&aid=${aid}&appName=${appName}`,data);
  },
  registerUser(aid,data){ //注册
    return post(`${COMM_HOST}/router/rest?method=ifeng.member.register&v=1.0&aid=${aid}`,data);
  },
  authMember(sid,aid,data){ // 专家活动验证是否登录1接口
    return post(`${COMM_HOST}/router/rest?method=ifeng.member.auth.member&v=1.0&sid=${sid}&aid=${aid}`,data);
  },
  authEncry(aid,data){ // 专家活动验证是否登录2接口
    return post(`${COMM_HOST}/router/rest?method=ifeng.member.auth.encry&v=1.0&aid=${aid}`,data);
  },
  getAwardRace(params){ //足球加奖
    return get(`${COMM_HOST}/router/rest?method=tq.activity.getAwardRace${params}`);
  },
  joinAwardRace(params){ //领取足球加奖
    return get(`${COMM_HOST}/router/rest?method=tq.activity.joinAwardRace${params}`);
  },
  getLeiTaiActivity(params){  //擂台赛活动信息
    return post(`${COMM_HOST}/router/rest?method=td.activity.competition&v=1.0${params}`,null);
  },
  getLeiTaiBoard(params){  //擂台赛排行榜
    return post(`${COMM_HOST}/router/rest?method=td.activity.competition.board&v=1.0${params}`,null);
  },
  getLeiTaiMyInfo(params){  //擂台赛我的信息
    return post(`${COMM_HOST}/router/rest?method=td.activity.competition.get&v=1.0${params}`,null);
  },
  getLeiTaiJoin(params){  //擂台赛参加擂台赛
    return post(`${COMM_HOST}/router/rest?method=td.activity.competition.join&v=1.0${params}`,null);
  },
  getInviteRegister(sid,aid,url){ // 邀请注册--获取邀请二维码
    return post(`${COMM_HOST}/router/rest?method=ifeng.invite.register.url&v=1.0&sid=${sid}&aid=${aid}&url=${url}`,null);
  },
  getInviteRegisterList(sid,aid){ // 邀请注册--获取邀请二维码
    return post(`${COMM_HOST}/router/rest?method=ifeng.invite.register.list&v=1.0&aid=1&sid=${sid}&aid=${aid}`,null);
  },
  getCZSInfo(params){  // 充值送活动
    return post(`${root}/A201902.do?v=1.0${params}`);
  },
  joinCZS(params){  // 充值送活动领取资格
    return post(`${root}/joinA201902.do?v=1.0${params}`,);
  },
  generateEuro(params){
    return post(`${root}/euro.do?v=1.0${params}`);
  },
  //获取冠军数据
  getChampion(params){
    return post(`${root}/euroChampion.do?v=1.0${params}`);
  },
  // 冠军之路销售发送手机验证码
  registerUserSms(data) {
    return post(`${root}/sale/sms.do?v=1.0`,data);
  },
  // 冠军之路销售注册新用户
  registerUserByChampion(data) {
    return post(`${root}/sale/euro.do?v=1.0`,data);
  },
  uploadPic(data){
    let url = root.replace('/activity','');
    return post(`${url}/c/uploadSellPicture.do`,data);
  },
  uploadPicV2(data){
    let url = root.replace('/activity','');
    return post(`${url}/c/uploadSellPictureV2.do`,data);
  },
  getWeChat(code){
    return get(`${XS_URL}ot/ppmqweess/${code}`);
  },
  getStoreInfo(params){ // 分享
    return post(`${COMM_HOST}/router/rest?method=ifeng.member.shop.getBindStatus&cv=3.3.0&v=1.0&aid=9998&cid=1${params}`,null);
  },
  inviteRegister(data){ //邀请码注册
    return post(`${COMM_HOST}/router/rest?method=ssn.member.invite.register&v=1.0`,data);
  },
  activityLucky(params){ //获取大转盘信息 method=tq.activity.member.today
    return get(`${COMM_HOST}/router/rest?method=tq.activity.lucky${params}`);
  },
  activityLuckyToday(params){ //获取大转盘今天的抽奖机会信息 
    return get(`${COMM_HOST}/router/rest?method=tq.activity.member.today&v=1.0${params}`);
  },
  myPrizeList(params){ //获取大转盘我的奖品信息 
    return get(`${COMM_HOST}/router/rest?method=tq.activity.member.list&v=1.0${params}`);
  },
  prizeList(params){ //获取大转盘奖品信息 
    return get(`${COMM_HOST}/router/rest?method=tq.activity.lucky.prize&v=1.0${params}`);
  },
  pushLottery(params){ //大转盘抽奖
    return get(`${COMM_HOST}/router/rest?method=tq.activity.open.draw&v=1.0${params}`);
  },
  identity(params){ //实名认证
    return get(`${COMM_HOST}/router/rest?method=ifeng.member.profile.complete.ac&v=1.0${params}`);
  },
  identityByYaoQing(params){ //实名认证
    return get(`${COMM_HOST}/router/rest?method=ifeng.member.profile.complete.acv2&v=1.0${params}`);
  },
  getLhHeroList(params){ //英雄榜连红轮播
    return get(`${COMM_HOST}/router/rest?method=tq.activity.heroic.redList&v=1.0${params}`);
  },
  getLhStatistics(params){ //英雄榜
    return get(`${COMM_HOST}/router/rest?method=tq.activity.heroic.statistics&v=1.0${params}`);
  },
  fdHeroRanking(params){ //发单榜
    return get(`${COMM_HOST}/router/rest?method=tq.activity.heroic.list&v=1.0${params}`);
  },
  querySignMonth(params,data){ //查询签到日历
    return post(`${COMM_HOST}/router/rest?method=ifeng.member.sign.query&v=1.0${params}`,data);
  },
  signInMonth(params,data){ //签到/补签
    return post(`${COMM_HOST}/router/rest?method=ifeng.member.sign.in&v=1.0${params}`,data);
  },
  helpSignInMonth(params,data){ //助力签到/补签
    return post(`${COMM_HOST}/router/rest?method=ifeng.member.sign.help&v=1.0${params}`,data);
  },
  questionnaire(params,data){  //提交问卷调查
    return post(`${COMM_HOST}/router/rest?method=ifeng.member.questionnaire&v=1.0${params}`,data);
  },
  getPostDetail(data){
    return post(`${COMM_HOST}/router/rest?method=tq.communitypost.detail&clientType=1&appName=web&v=1.0&cv=3.6.4&aid=1&cid=1`,data);
  },
  getPlanDetail(data){
    return post(`${COMM_HOST}/router/rest?method=tq.communitypost.planDetail&clientType=1&appName=web&v=1.0&cv=3.6.4&aid=1&cid=1`,data);
  },
  giftcardAmount(params,data){  //聊球命中榜活动规则数据
    return post(`${COMM_HOST}/router/rest?method=tq.communityActivity.giftcardAmount&v=1.0${params}`,data);
  },
  communityActivityIng(params,data){  //获取聊球命中榜进行中的期次排名
    return post(`${COMM_HOST}/router/rest?method=tq.communityActivity.ing&v=1.0${params}`,data);
  },
  communityActivityAwardlist(params,data){  //获取聊球命中榜上一轮的期次排名
    return post(`${COMM_HOST}/router/rest?method=tq.communityActivity.awardlist&v=1.0${params}`,data);
  },
  getKoiDetail(params,data){ //注册
    return post(`${COMM_HOST}/router/rest?method=tq.activity.koi.list&v=1.0${params}`,data);
  },
  getKoiTicket(params,data){ //注册
    return post(`${COMM_HOST}/router/rest?method=tq.activity.koi.tickets&v=1.0${params}`,data);
  },
  koiDraw(params,data){ //注册
    return post(`${COMM_HOST}/router/rest?method=tq.activity.koi.draw&v=1.0${params}`,data);
  },
  koiHelp(params,data){ //注册
    return post(`${COMM_HOST}/router/rest?method=tq.activity.koi.help&v=1.0${params}`,data);
  },
  getHeroicPlanRecords(params){ //获取英雄榜发单记录列表
    return get(`${COMM_HOST}/router/rest?method=tq.activity.heroic.planRecords&v=1.0${params}`);
  },
  getScoreGuessStatus(params){ //查询竞猜资格状态
    return post(`${COMM_HOST}/router/rest?method=tq.activity.scoreGuess.status&v=1.0${params}`, null);
  },
  getScoreGuessMatch(params){ //获取销售中竞猜赛事列表
    return post(`${COMM_HOST}/router/rest?method=tq.activity.scoreGuess.match&v=1.0${params}`, null);
  },
  getScoreGuessPrizes(params){ //获取可选奖品列表
    return post(`${COMM_HOST}/router/rest?method=tq.activity.scoreGuess.prizes&v=1.0${params}`, null);
  },
  claimSpend(params){ //领取消费达标竞猜资格
    return post(`${COMM_HOST}/router/rest?method=tq.activity.scoreGuess.claimSpend&v=1.0${params}`, null);
  },
  getGuessHistory(params){ //查询当前用户竞猜记录
    return post(`${COMM_HOST}/router/rest?method=tq.activity.scoreGuess.history&v=1.0${params}`, null);
  },
  submitGuess(data){ //提交竞猜
    return post(`${COMM_HOST}/router/rest?method=tq.activity.scoreGuess.submit&v=1.0`, data);
  },
  claimDaily(params){ //领取每日登录竞猜资格
    return post(`${COMM_HOST}/router/rest?method=tq.activity.scoreGuess.claimDaily&v=1.0${params}`, null);
  },
  isSellChannel(params){ //领取每日登录竞猜资格
    return post(`${COMM_HOST}/router/rest?method=tq.activity.heroic.isSellChannel&v=1.0${params}`, null);
  },
}



export default httpApi



// WEBPACK FOOTER //
// ./src/http/api.js